import { styled } from '@mui/material/styles';
import { DateTimePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';

export const StyledDatePicker = styled(DateTimePicker<Dayjs>)(
  ({ theme, value }) => ({
    color: theme.palette.custom.black[90],
    lineHeight: '100%',
    borderRadius: '14px',
    backgroundColor: 'white',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.custom.black[!value ? 10 : 90],
      borderRadius: '14px',
    },

    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.custom.black[30],
      opacity: 1,
    },

    '&:hover:not(.Mui-disabled)': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.black[30],
      },
    },

    '&.Mui-error': {
      color: theme.palette.error.main,

      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.error.main,
      },
    },

    '&.Mui-disabled': {
      borderRadius: '14px',
      backgroundColor: theme.palette.custom.grey3,
      borderColor: theme.palette.custom.black[20],
    },
  })
);
